import Component from '../core/Component'
import { triggerEvent } from '../utils/dom'
import { EMITS as AUTOCOMPLETE_EMITS } from './Autocomplete'
import { EMITS as GPSRETRIEVER_EMITS } from './GpsRetriever'

const TABS1NAME = 'category'
const TABS2NAME = 'type'

export default class ContactSearch extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            autocomplete: null,
            gpsRetriever: null,
            lat: null,
            lng: null,
            id: null
        }
    }

    prepare() {
        if (this.ref.autocomplete) {
            this.autocomplete = Component.getFromElement(this.ref.autocomplete)
            this.autocomplete.on(AUTOCOMPLETE_EMITS.SELECT, this.handleAutocompleteSelect)
            this.autocomplete.on(AUTOCOMPLETE_EMITS.CHANGE, this.handleAutocompleteChange)

            //highjack autocomplete url, nacpani dalsich parametru pred tim, nez se posle request, aby se dalo rozlisit pobocky, financni poradci atp.
            this.autocomplete.options.searchEngineOptions.onUrlBuild = ({ url }) => {
                return url
                    .replace('__CATEGORY__',this.getTab1Value())
                    .replace('__TYPE__',this.getTab2Value())
            }
        }

        if (this.ref.gpsRetriever) {
            this.gpsRetriever = Component.getFromElement(this.ref.gpsRetriever)
            this.gpsRetriever.on(GPSRETRIEVER_EMITS.POSITION_FETCHED, this.handleGpsRetrieverPositionFetched)
        }

        this.element.addEventListener('change', this.handleChange)
    }

    //kdyz se klikne na gpsku, submitne to jen lat,lng a query
    handleGpsRetrieverPositionFetched = ({ lat, lng }) => {
        this.setOrClearValues({
            lat,
            lng
        })
        this.element.submit()
    }

    //kdyz se vybere z autocomplete, submitne se jen id a query
    handleAutocompleteSelect = async () => {
        const value = await this.autocomplete.getValue()
        this.setOrClearValues({
            id: value?.id
        })
        this.element.submit()
    }

    //kdyz se zmeni autocomplete, promazat id,lat,lng, aby submit poslal jen query
    handleAutocompleteChange = () => {
        this.setOrClearValues()
    }

    handleChange = (event) => {
        if (event.target.name === TABS1NAME || event.target.name === TABS2NAME) {
            this.autocomplete?.clearCache()
            this.autocomplete?.hide()
            this.checkGpsRetrieverVisibility()
        }
    }

    setOrClearValues({ lat, lng, id } = {}) {
        this.ref.id.value = id ?? ''
        this.ref.lat.value = lat ?? ''
        this.ref.lng.value = lng ?? ''
    }

    getTab1Value() {
        return ([...this.element[TABS1NAME] ?? []].find(radioEl => radioEl.checked))?.value
    }

    getTab2Value() {
        return ([...this.element[TABS2NAME] ?? []].find(radioEl => radioEl.checked))?.value
    }

    setTabs1Value(value) {
        const radioEl = [...this.element[TABS1NAME] ?? []].find(radioEl => radioEl.value === value)
        if (!radioEl) {
            return
        }
        radioEl.checked = true
        triggerEvent(radioEl, 'change')
    }

    checkGpsRetrieverVisibility() {
        const tab1value = this.getTab1Value()
        const tab2value = this.getTab2Value()

        //taby nebo gpsretriever neexistujou
        if (!tab1value && !tab2value && !this.ref.gpsRetriever) {
            return
        }

        const isVisible = tab1value === '1' || (tab1value !== '1' && tab2value === '2')
        this.ref.gpsRetriever.classList.toggle('hidden', !isVisible)
    }
}